module.exports = __webpack_public_path__ + "img/mobile_title.481570a7.png";